import * as React from "react"
import { Link } from "react-router-dom"
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import { Typography } from "@mui/material";

const Calendar = () => (
  <><NavigationBar/>
  {/* Hero Image */}
<div style={{ display: "grid" }}>
  <img
    style={{
      gridArea: "1/1",
      // maxHeight: 600,
    }}
    layout="fullWidth"
    aspectRatio={3 / 1}
    alt=""
    src="/calendarBanner.jpg"
  quality="40"
    formats={["auto", "webp", "avif"]}/>
  <div
    style={{
      gridArea: "1/1",
      position: "relative",
      placeItems: "center",
      display: "grid",
    }}
  >
  </div>
</div>
{/* Main Content */}
  <Layout>
  <div id="861077265476382518" align="left" style={{width: "100%", overflowY: "hidden"}} class="wcustomhtml"><iframe src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23B39DDB&ctz=America%2FLos_Angeles&src=NWIyYTMzMjgxMDI3OThiZTRiZjViNGVmNzI1MWFlOWNkNTBkNDRjMmI0OWRjMzJiNDhlN2UxYTQ0MGU2NGU3NUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%238d4b08" style={{border:"solid 1px #777"}} width="900" height="600" frameborder="0" scrolling="no"></iframe></div>


      <Typography variant="h3" style={{textAlign: "center"}}>
      <strong>2024 年活動日曆</strong>
      </Typography><br/>
  <a href="/eventsCalendar.png"><img src="/eventsCalendar.png" /></a>
  </Layout>
  </>
)

export default Calendar
